/* eslint-disable react-hooks/exhaustive-deps */
import useFetch from '@hooks/useFetch';
import useMyInfo from '../auth/useMyInfo';

const useStoreFilters = (
  goalUID,
  options = { selector: null, fallbackData: undefined }
) => {
  const { isValidating: userValidating } = useMyInfo();
  const key = `v1/store/sku/filters?goal_uid=${goalUID}`;

  const {
    data: storeFilters,
    isValidating,
    ...rest
  } = useFetch(
    goalUID && !userValidating ? key : null,
    {},
    { fallbackData: options.fallbackData }
  );

  if (options.selector && typeof options.selector === 'function')
    return options.selector(storeFilters || {});

  return {
    key,
    storeFilters,
    isValidating,
    ...rest
  };
};

export default useStoreFilters;
